import TruckingReactAPI from '../../lib/TruckingReactAPI';
import { handleError, error, receive, request } from '../../lib/Utils';

import SwaggerApi, { callApi } from '../../lib/SwaggerApi';

import fetch from 'isomorphic-fetch';


export const UPDATE_CAPACITY = {
  REQUEST: "UPDATE_CAPACITY_REQUEST",
  SUCCESS: "UPDATE_CAPACITY_SUCCESS",
  FAILURE: "UPDATE_CAPACITY_FAILURE"
};

export const ALL_CAPACITY = {
  REQUEST: "ALL_CAPACITY_REQUEST",
  SUCCESS: "ALL_CAPACITY_SUCCESS",
  FAILURE: "ALL_CAPACITY_FAILURE"
};

export const CAPACITY = {
  REQUEST: "CAPACITY_REQUEST",
  SUCCESS: "CAPACITY_SUCCESS",
  FAILURE: "CAPACITY_FAILURE"
};

export const TERMINALS = {
  REQUEST: "TERMINALS_REQUEST",
  SUCCESS: "TERMINALS_SUCCESS",
  FAILURE: "TERMINALS_FAILURE"
};

export const POTENTIAL_DESTINATIONS = {
  REQUEST: "DESTINATIONS_REQUEST",
  SUCCESS: "DESTINATIONS_SUCCESS",
  FAILURE: "DESTINATIONS_FAILURE"
};

export const QUOTE = {
  REQUEST: "QUOTE_REQUEST",
  SUCCESS: "QUOTE_SUCCESS",
  FAILURE: "QUOTE_FAILURE"
};

export const JOB_REQUEST = {
  REQUEST: "JOB_REQUEST_REQUEST",
  SUCCESS: "JOB_REQUEST_SUCCESS",
  FAILURE: "JOB_REQUEST_FAILURE"
};

export const FLAT_RATE = {
  REQUEST: "FLAT_RATE_REQUEST",
  SUCCESS: "FLAT_RATE_SUCCESS",
  FAILURE: "FLAT_RATE_FAILURE"
};

export const RATE_SHEET = {
  REQUEST: "RATE_SHEET_REQUEST",
  SUCCESS: "RATE_SHEET_SUCCESS",
  FAILURE: "RATE_SHEET_FAILURE"
};

export const IMPORT_SHEET = {
  REQUEST: "IMPORT_SHEET_REQUEST",
  SUCCESS: "IMPORT_SHEET_SUCCESS",
  FAILURE: "IMPORT_SHEET_FAILURE"
};

export const UPDATE_RATE_SHEET = {
  REQUEST: "UPDATE_RATE_SHEET_REQUEST",
  SUCCESS: "UPDATE_RATE_SHEET_SUCCESS",
  FAILURE: "UPDATE_RATE_SHEET_FAILURE"
};

export const DELETE_RATES = {
  REQUEST: "DELETE_RATES_REQUEST",
  SUCCESS: "DELETE_RATES_SUCCESS",
  FAILURE: "DELETE_RATES_FAILURE"
};


export const GET_ACCESSORIAL_SHEET = {
  REQUEST: "GET_ACCESSORIAL_SHEET_REQUEST",
  SUCCESS: "GET_ACCESSORIAL_SHEET_SUCCESS",
  FAILURE: "GET_ACCESSORIAL_SHEET_FAILURE"
};


export const DESTINATIONS = {
  REQUEST: "GET_DESTINATIONS_REQUEST",
  SUCCESS: "GET_DESTINATIONS_SUCCESS",
  FAILURE: "GET_DESTINATIONS_FAILURE"
};


export const STATES = {
  REQUEST: "GET_STATES_REQUEST",
  SUCCESS: "GET_STATES_SUCCESS",
  FAILURE: "GET_STATES_FAILURE"
};


export const ZIP_CODES = {
  REQUEST: "GET_ZIP_CODES_REQUEST",
  SUCCESS: "GET_ZIP_CODES_SUCCESS",
  FAILURE: "GET_ZIP_CODES_FAILURE"
};


export const CLEAR_QUOTE = "CLEAR_QUOTE";

let api = new TruckingReactAPI({ domain: '/api' });




export function addRateData(parameters, callback) {
  return callApi(parameters, "Business", "addRates", UPDATE_RATE_SHEET, callback);
}

export function getRateSheet(parameters, callback) {
  return callApi(parameters, "Business", "getRateSheet", RATE_SHEET, callback);
}

export function getDestinations(parameters, callback) {
  return callApi(parameters, "Business", "getDestinations", DESTINATIONS, callback);
}
export function getStates(parameters, callback) {
  return callApi(parameters, "Business", "getStates", STATES, callback);
}
export function getZipCodes(parameters, callback) {
  return callApi(parameters, "Business", "getZipCodes", ZIP_CODES, callback);
}

export function deleteRateData(parameters, callback) {
  return callApi(parameters, "Business", "deleteRates", DELETE_RATES, callback);
}

export function getRateSheetCSV(parameters, callback) {
  return (dispatch) => {
    let downloadCSVLink = `/api/rates?terminalId=${parameters.terminalId}&orgId=${parameters.orgId}&fileFormat=csv`;
    fetch(downloadCSVLink, {
      method: 'GET',
      credentials: 'same-origin'
    }).then((payload) => {
      if (payload.ok) {
        payload.text().then(text => {
          callback(null, text);
        });
      }
      else {
        callback({
          message: payload.statusText
        });
      }
    })
      .catch(function (err) {
        callback(err);
      });
  };
}

export function importCSV(parameters, callback = () => false) {
  return (dispatch) => {
    dispatch(request(IMPORT_SHEET));

    var formData = new FormData();
    formData.append('file', parameters.file);

    let putCSVLink = `/api/rates?terminalId=${parameters.terminalId}&orgId=${parameters.orgId}&fileFormat=${parameters.fileFormat}`;

    return fetch(putCSVLink, {
      method: 'PUT',
      body: formData,
      credentials: 'same-origin'
    }).then((payload) => {
      if (payload.ok) {
        payload.json().then(json => {
          dispatch(receive(IMPORT_SHEET, json));
          callback(null, json);
        });        
      }
      else {
        handleError(dispatch, payload, IMPORT_SHEET, callback);
      }
    })
      .catch(function (err) {
        dispatch(error(IMPORT_SHEET, {
          message: err.message
        }));
        callback(err);
      });
  };
}

export function updateRateSheet(parameters, callback) {
  return (dispatch) => {

    dispatch(request(UPDATE_RATE_SHEET));

    return api
      .updateRateSheet(parameters)
      .then((payload) => {
        if (payload.ok) {
          payload
            .json()
            .then(json => {
              dispatch(receive(UPDATE_RATE_SHEET, json));
              if (callback) {
                callback(null, json);
              }
            });
        } else {
          handleError(dispatch, payload, UPDATE_RATE_SHEET);
          if (callback) {
            callback(new Error(payload.statusText));
          }
        }
      }).catch(function (err) {
        dispatch(error(UPDATE_RATE_SHEET, {
          message: err.message
        }));
        if (callback) {
          callback(err);
        }
      });
  };
}
export function getAllCapacities(parameters, callback) {
  return (dispatch) => {

    dispatch(request(ALL_CAPACITY));

    return api
      .getCapacity(parameters)
      .then((payload) => {
        if (payload.ok) {
          payload
            .json()
            .then(json => {
              dispatch(receive(ALL_CAPACITY, json));
              if (callback) {
                callback(null, json);
              }
            });
        } else {
          handleError(dispatch, payload, ALL_CAPACITY);
          if (callback) {
            callback(new Error(payload.statusText));
          }
        }
      }).catch(function (err) {
        dispatch(error(ALL_CAPACITY, {
          message: err.message
        }));
        if (callback) {
          callback(err);
        }
      });
  };
}

export function getCapacity(parameters, callback) {
  return (dispatch) => {

    dispatch({
      type: CAPACITY.REQUEST,
      terminal: parameters.terminal
    });

    return api
      .getCapacity(parameters)
      .then((payload) => {
        if (payload.ok) {
          payload
            .json()
            .then(json => {

              let capacity = {};
              capacity[parameters.terminal] = json;

              dispatch({
                type: CAPACITY.SUCCESS,
                terminal: parameters.terminal,
                payload: json
              });

              //dispatch(receive(CAPACITY, capacity));
              if (callback) {
                callback(null, json);
              }
            });
        } else {


          dispatch({
            type: CAPACITY.FAILURE,
            terminal: parameters.terminal,
            error: {
              statusCode: payload.status,
              message: payload.statusText
            }
          });

          //handleError(dispatch, payload, CAPACITY);
          if (callback) {
            callback(new Error(payload.statusText));
          }
        }
      }).catch(function (err) {
        dispatch({
          type: CAPACITY.FAILURE,
          terminal: parameters.terminal,
          error: {
            statusCode: -1,
            message: err.message
          }
        });
        if (callback) {
          callback(err);
        }
      });
  };
}

export function updateCapacity(terminals, callback) {
  return (dispatch) => {

    dispatch(request(UPDATE_CAPACITY));

    return api
      .updateCapacity({
        body: {
          terminals
        }
      })
      .then((payload) => {
        if (payload.ok) {
          payload
            .json()
            .then(json => {
              dispatch(receive(UPDATE_CAPACITY, json));
              if (callback) {
                callback(null, json);
              }
            });
        } else {
          handleError(dispatch, payload, UPDATE_CAPACITY);
          if (callback) {
            callback(new Error(payload.statusText));
          }
        }
      }).catch(function (err) {
        dispatch(error(UPDATE_CAPACITY, {
          message: err.message
        }));
        if (callback) {
          callback(err);
        }
      });
  };
}

export function getTerminals(callback) {
  return (dispatch) => {
    dispatch(request(TERMINALS));
    return api
      .getTerminals()
      .then((payload) => {
        if (payload.ok) {
          payload
            .json()
            .then(json => {
              dispatch(receive(TERMINALS, json));
              if (callback) {
                callback(null, json);
              }
            });
        } else {
          handleError(dispatch, payload, TERMINALS);
          if (callback) {
            callback(new Error(payload.statusText));
          }
        }
      }).catch(function (err) {
        dispatch(error(TERMINALS, {
          message: err.message
        }));
        if (callback) {
          callback(err);
        }
      });
  };
}

export function getPotentialDestinations(parameters, callback = () => false) {
  return (dispatch) => {
    dispatch(request(POTENTIAL_DESTINATIONS));
    return api
      .getPotentialDestinations(parameters)
      .then((payload) => {
        if (payload.ok) {
          payload
            .json()
            .then(json => {
              dispatch(receive(POTENTIAL_DESTINATIONS, json));
              callback(null, json);
            });
        } else {
          handleError(dispatch, payload, POTENTIAL_DESTINATIONS, callback);
        }
      }).catch(function (err) {
        dispatch(error(POTENTIAL_DESTINATIONS, {
          message: err.message
        }));
        callback(err);
      });
  };
}

/*
export function jobRequestV1(parameters) {

  var formData = new FormData();

  if (parameters.files) {
    parameters.files.forEach(file => {
      formData.append("files", file);
    });
  }

  Object.entries(parameters).forEach(keyVal => {
    if (keyVal.key != "files") {
      formData.append(...keyVal);
    }
  });

  return (dispatch) => {
    dispatch(request(JOB_REQUEST));

    return fetch('/api/jobs-v1', {
      method: 'POST',
      body: formData,
      credentials: 'same-origin'
    }).then((payload) => {
      // console.log(payload);
      if (payload.ok) {
        dispatch(receive(JOB_REQUEST));
      }
      else {
        handleError(dispatch, payload, JOB_REQUEST);
      }
    })
      .catch(function (err) {
        dispatch(error(JOB_REQUEST, {
          message: err.message
        }));
      });
  };
}
*/

export function createQuote(parameters, callback) {
  return (dispatch) => {

    dispatch(request(QUOTE));
    return api
      .createQuote(parameters)
      .then((payload) => {
        if (payload.ok) {
          payload
            .json()
            .then(json => {
              dispatch(receive(QUOTE, json));
              callback(null, json);
            });
        } else {
          handleError(dispatch, payload, QUOTE, callback);
        }
      }).catch(function (err) {
        dispatch(error(QUOTE, {
          message: err.message
        }));
        callback(err);
      });
  };
}

export function getFlatRate(request) {
  return (dispatch) => {

    dispatch(request(FLAT_RATE));

    let parameters = {
      ...request
    };

    return api
      .getFlatRate(parameters)
      .then((payload) => {
        if (payload.ok) {
          payload
            .json()
            .then(json => {
              dispatch(receive(FLAT_RATE, json));
            });
        } else {

          handleError(dispatch, payload, QUOTE);
        }
      });
  };
}

export function clearQuote() {
  return {
    type: CLEAR_QUOTE
  };
}


// WEBPACK FOOTER //
// ./src/containers/Dashboard/DashboardActions.js